// oxlint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function isInstanceOfAny<T>(value: T, options: [Function, ...Function[]]): boolean {
    return options.some((option) => value instanceof option);
}
